import { takeLatest, put } from 'redux-saga/effects';
import actionCreator from 'utils/actionCreator';
import axios from 'utils/axios';
import { ordersActions } from './orders';

/**
 * Action Types
 */
export const ordersReadActionTypes = {
    REQUEST: '@app/orders/read/REQUEST',
    FAILURE: '@app/orders/read/FAILURE',
    SUCCESS: '@app/orders/read/SUCCESS',
}

/**
 * Redux Actions
 */
export const ordersReadActions = {
    request: actionCreator(ordersReadActionTypes.REQUEST),
    success: actionCreator(ordersReadActionTypes.SUCCESS),
    failure: actionCreator(ordersReadActionTypes.FAILURE)
};

/**
 * Saga Functions
 */
export const sagas = {
    *request({ payload, resolve, reject }) {
        try {
            const res = yield axios.get('/orders', { params: payload });

            yield put(ordersActions.read({ orders: res.data.results, total: res.data.total }));
            yield put(ordersReadActions.success());

            resolve(res.data);
        } catch (err) {
            yield put(ordersReadActions.failure(err.response.data.errors));
            reject(err);
        }
    }
}

/**
 * Saga Watchers
 */
export const ordersReadWatchers = function* () {
    yield takeLatest(ordersReadActionTypes.REQUEST, sagas.request)
}
